/**
 * @import { Ref } from 'vue'
 */
import { ref } from 'vue'
import { dependedCharConvert } from '@/utils/DependedChar'
import { isValidFormat } from '@/utils/Email'

/**
 * @param {{inputCompanyEmail: string, inputCompanyPw: string}} props
 * @param {Ref<HTMLFormElement|undefined>} refForm
 * @returns
 */
export const setup = (props, refForm) => {
  const companyEmail = ref(props.inputCompanyEmail)
  const companyPw = ref(props.inputCompanyPw)
  const violationForm = ref(true)

  /** @type { Ref<string[]> } */
  const companyEMAILErrorMessage = ref([])
  /** @type { Ref<string[]> } */
  const companyPWErrorMessage = ref([])

  /** @type {Ref<boolean>} */
  const violationCompanyPWForm = ref(false)

  const refResetMailSendModal = ref(null)
  const refPwSettingDoneModal = ref(null)
  const refPwResetDoneModal = ref(null)

  const formSubmit = () => {
    refForm.value?.submit()
  }

  /**
   * @param {string} _text
   * @param {number} _minLength
   * @param {number} _maxLength
   * @return boolean
   */
  const CheckViolationTextLength = function (_text, _minLength, _maxLength) {
    let violationTextLength = false
    const text = dependedCharConvert(_text.replace(/\r?\n/g, ''))
    if (text.length <= _minLength || text.length > _maxLength) {
      violationTextLength = true
    } else {
      violationTextLength = false
    }
    return violationTextLength
  }

  const checkCompanyEMAILLength = () => {
    if (!isValidFormat(companyEmail.value) && companyEmail.value.length !== 0) {
      companyEMAILErrorMessage.value = ['メールアドレスは正しい形式で入力してください']
    } else {
      companyEMAILErrorMessage.value = []
    }

    violationForm.value = violationFormValue()
  }

  const checkCompanyPWLength = () => {
    const companyPWText = companyPw.value
    violationCompanyPWForm.value = CheckViolationTextLength(companyPWText, 5, 20)
    // 「文字数違反」かつ「テキストが入力されている」場合、エラーメッセージを表示する。
    if (violationCompanyPWForm.value && companyPWText.length !== 0) {
      companyPWErrorMessage.value = ['「パスワード」は6～20文字で入力してください。']
      violationForm.value = true
    } else {
      companyPWErrorMessage.value = []
      violationForm.value = violationFormValue()
    }
  }

  // 制御に掛かった場合ボタンを不活性化
  const violationFormValue = () => {
    // ID && PWに入力が存在
    if (companyEmail.value && companyPw.value) {
      return companyEMAILErrorMessage.value.length !== 0 || companyPWErrorMessage.value.length !== 0
    } else {
      // 入力に不足がある
      return true
    }
  }

  return {
    companyEmail: companyEmail,
    companyPw: companyPw,

    companyEMAILErrorMessage: companyEMAILErrorMessage,
    companyPWErrorMessage: companyPWErrorMessage,

    violationForm: violationForm,
    refResetMailSendModal: refResetMailSendModal,
    refPwResetDoneModal: refPwResetDoneModal,
    refPwSettingDoneModal: refPwSettingDoneModal,

    formSubmit: formSubmit,
    checkCompanyEMAILLength: checkCompanyEMAILLength,
    checkCompanyPWLength: checkCompanyPWLength,
  }
}
